const Dashboard = () => {
  return <div className="title"> Weclome to RealFM admin dashboard</div>;
};

export default Dashboard;
